import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=0cc966a8&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=0cc966a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc966a8",
  null
  
)

export default component.exports